// src/features/streams/schemas/SimulcastForm.schema.ts

import { z } from 'zod';
import { SIMULCAST_CONSTRAINTS } from '@/lib/constants/simulcast';

// RTMP form schema (create + edit)
export const rtmpFormSchema = z.object({
  label: z.string().min(SIMULCAST_CONSTRAINTS.LABEL_MIN, 'Destination name is required').max(SIMULCAST_CONSTRAINTS.LABEL_MAX),
  rtmpServerUrl: z.string().min(1, 'Server URL is required').max(SIMULCAST_CONSTRAINTS.RTMP_SERVER_URL_MAX),
  rtmpStreamKey: z.string().min(1, 'Stream key is required').max(SIMULCAST_CONSTRAINTS.RTMP_STREAM_KEY_MAX),
  rtmpUser: z.string().max(SIMULCAST_CONSTRAINTS.RTMP_USER_MAX),
  rtmpPass: z.string().max(SIMULCAST_CONSTRAINTS.RTMP_PASS_MAX),
  retry: z.boolean(),
});
export type RtmpFormData = z.infer<typeof rtmpFormSchema>;

// Facebook edit form (post-creation: label/title/desc only)
export const fbEditFormSchema = z.object({
  label: z.string().min(SIMULCAST_CONSTRAINTS.LABEL_MIN, 'Destination name is required').max(SIMULCAST_CONSTRAINTS.LABEL_MAX),
  title: z.string().max(SIMULCAST_CONSTRAINTS.TITLE_MAX),
  descShort: z.string().max(SIMULCAST_CONSTRAINTS.DESC_SHORT_MAX),
});
export type FBEditFormData = z.infer<typeof fbEditFormSchema>;

// YouTube edit form (post-creation: label/title/desc only)
export const ytEditFormSchema = z.object({
  label: z.string().min(SIMULCAST_CONSTRAINTS.LABEL_MIN, 'Destination name is required').max(SIMULCAST_CONSTRAINTS.LABEL_MAX),
  title: z.string().max(SIMULCAST_CONSTRAINTS.TITLE_MAX),
  descShort: z.string().max(SIMULCAST_CONSTRAINTS.DESC_SHORT_MAX),
});
export type YTEditFormData = z.infer<typeof ytEditFormSchema>;

// Facebook create form (simplified — broken broadcast options removed, defaults hardcoded in transforms)
export const fbCreateFormSchema = z.object({
  label: z.string().min(SIMULCAST_CONSTRAINTS.LABEL_MIN, 'Destination name is required').max(SIMULCAST_CONSTRAINTS.LABEL_MAX),
  title: z.string().max(SIMULCAST_CONSTRAINTS.TITLE_MAX),
  descShort: z.string().max(SIMULCAST_CONSTRAINTS.DESC_SHORT_MAX),
});
export type FBCreateFormData = z.infer<typeof fbCreateFormSchema>;

// YouTube create form (simplified — broken broadcast options removed, defaults hardcoded in transforms)
export const ytCreateFormSchema = z.object({
  label: z.string().min(SIMULCAST_CONSTRAINTS.LABEL_MIN, 'Destination name is required').max(SIMULCAST_CONSTRAINTS.LABEL_MAX),
  title: z.string().max(SIMULCAST_CONSTRAINTS.TITLE_MAX),
  descShort: z.string().max(SIMULCAST_CONSTRAINTS.DESC_SHORT_MAX),
});
export type YTCreateFormData = z.infer<typeof ytCreateFormSchema>;
